import { render, staticRenderFns } from "./WorkPlaceModal.vue?vue&type=template&id=81ed9f68&"
import script from "./WorkPlaceModal.vue?vue&type=script&lang=js&"
export * from "./WorkPlaceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports